import { Cause, StateData } from '@interfaces';

type Listener = () => void;

export interface InspiredStateData {
  causes: string[];
  selectedCause: string | null;
}

class InspiredStateHandler {
  private state: StateData = {
    storeName: '',
    campaign: { donationAmount: 1, donationType: 'percentage', collectionId: '' },
    donationString: '',
    causes: [],
    bannerConfig: {
      options: {},
      content: {},
      colors: { primary: '#000', secondary: '#000', tertiary: '#000' },
      placements: []
    },
    embeddedCartConfig: {
      options: {},
      content: {},
      colors: { primary: '#000', secondary: '#000', tertiary: '#000' },
      placements: []
    },
    embeddedCartDrawerConfig: {
      options: {},
      content: {},
      colors: { primary: '#000', secondary: '#000', tertiary: '#000' },
      placements: []
    },
    embeddedProductConfig: {
      options: {},
      content: {},
      colors: { primary: '#000', secondary: '#000', tertiary: '#000' },
      placements: []
    },
    floatingConfig: {
      options: {},
      content: {},
      colors: { primary: '#000', secondary: '#000', tertiary: '#000' }
    },
    pageSectionConfig: {
      options: {},
      content: {},
      colors: { primary: '#000', secondary: '#000', tertiary: '#000' }
    },
    progressCartConfig: {
      options: {},
      content: {},
      colors: { primary: '#000', secondary: '#000', tertiary: '#000' }
    }
  };
  private listeners: Listener[] = [];

  // set the list of causes and notify listeners
  setData(data: StateData) {
    this.state = { ...this.state, ...data }; // merge new data into existing state
    this.notifyListeners(); // notify all subscribed listeners of the change
  }

  // set the selected cause and notify listeners if it has changed
  // this will be the same pattern as any other events the widgets trigger
  setSelectedCause(cause: Cause) {
    if (this.state.selectedCause !== cause) {
      this.state.selectedCause = cause;
      this.notifyListeners();
    }
  }

  // get current state
  getState(): StateData {
    return { ...this.state };
  }

  // subscribe a listener function to state changes
  subscribe(listener: Listener) {
    this.listeners.push(listener);
  }

  // unsubscribe a listener function from state changes
  unsubscribe(listener: Listener) {
    this.listeners = this.listeners.filter(l => l !== listener);
  }

  // notify all subscribed listeners about a state change
  private notifyListeners() {
    for (const listener of this.listeners) {
      listener();
    }
  }
}

export const stateHandler = new InspiredStateHandler();
